
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

type FontAwesomeStyles = 'solid' | 'regular' | 'light' | 'thin' | 'duotone'
/**
 * Relative Sizing Class  Font Size   Equivalent in Pixels
 * --------------------------------------------------------
 * fa-2xs                 0.625em     10px
 * fa-xs                  0.75em      12px
 * fa-sm                  0.875em     14px
 * fa-lg                  1.25em      20px
 * fa-xl                  1.5em       24px
 * fa-2xl                 2em         32px
 */
type RelativeSizing = '2xs' | 'xs' | 'sm' | '' | 'lg' | 'xl' | '2xl'
/**
 * Literal Sizing Class   Font Size
 * --------------------------------------------------------
 * fa-1x                  1em
 * fa-2x                  2em
 * fa-3x                  3em
 * fa-4x                  4em
 * fa-5x                  5em
 * fa-6x                  6em
 * fa-7x                  7em
 * fa-8x                  8em
 * fa-9x                  9em
 * fa-10x                 10em
 */
type LiteralSizing = '1x' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x'
type FontAwesomeSizes = RelativeSizing & LiteralSizing

@Component
export default class IconButton extends Vue {
  @Prop({type: String, default: 'solid'}) mStyle!: FontAwesomeStyles
  @Prop({type: String, default: ''}) size!: FontAwesomeSizes
  @Prop({type: String, required: true}) name!: string

  get classNames() {
    const {mStyle, name, size} = this
    let className = `fa-${mStyle} ${name}`
    if (size !== '') className += ` ft-${size}`
    return className
  }
}
